"use strict";

define('rs/services/abstract.service',['vertebrae', 'rs/cache'], function (Vertebrae, Cache) {
  var AbstractService = Vertebrae.Object.extend({
    initialize: function initialize(properties) {
      this.cache = Cache(this);
      if (properties) {
        this.configure(properties);
      }
      this._super.apply(this, arguments);
    },
    configure: function configure(properties) {
      this.clear();
      this.applyProperties(properties);
      return this;
    },
    has: function has(property) {
      return this.cache.has(property);
    },
    clear: function clear() {
      var properties = this.properties,
        len = properties ? properties.length : 0,
        i = 0;
      if (arguments.length > 0) {
        this.cache.clear(arguments[0]);
        return this;
      }
      this.cache.clear();
      for (i = 0; i < len; ++i) {
        this.setter(properties[i], null);
      }
      this.stopListening();
      return this;
    },
    load: function load(properties) {
      if (!_.isArray(properties)) {
        properties = _.toArray(arguments);
      }
      var promises = [],
        len = properties.length,
        i = 0;
      function get(obj, prop) {
        if (obj.hasGetter(prop)) {
          return obj.getter(prop);
        } else {
          return obj.get(prop);
        }
      }
      ;
      function property(obj, prop) {
        if (prop.indexOf('.') > -1) {
          var properties = prop.split('.');
          return Promise.resolve(get(obj, properties[0])).then(function (resolvedObj) {
            return property(resolvedObj, properties.slice(1).join('.'));
          });
        } else {
          return get(obj, prop);
        }
      }
      ;
      for (i = 0; i < len; ++i) {
        promises.push(property(this, String(properties[i])));
      }
      return Promise.all(promises);
    },
    update: function update(properties) {
      var toLoad = [];
      if (!_.isArray(properties)) {
        properties = _.toArray(arguments);
      }
      for (var i = 0, len = properties.length, property; i < len; i++) {
        property = properties[i];
        if (this.has(property)) {
          this.clear(property);
          toLoad.push(property);
        }
      }
      return this.load(toLoad).lastly(this.getApp().showLoading());
    },
    validate: function validate(properties, validation) {
      var errors = [];
      _.each(properties, function (value, property) {
        var valid = Vertebrae.Validator.validateValueWithMiddleware(value, property, validation[property], this);
        if (valid !== true) {
          errors.push(valid);
        }
      });
      if (_.isEmpty(errors)) {
        return true;
      }
      throw new Error(errors);
    },
    hasPermission: function hasPermission(permission) {
      return this.checkPermission(permission);
    },
    hasRole: function hasRole(role) {
      return this.getApp().checkRole(role);
    },
    checkPermission: function checkPermission(permission) {
      return this.getApp().checkPermission(permission);
    },
    getApp: function getApp() {
      return AbstractService.app;
    },
    getUser: function getUser() {
      return this.getApp().getUser();
    },
    getPerson: function getPerson() {
      return this.getUser().getPerson();
    },
    sortPropertyBy: function sortPropertyBy(property, field) {
      var sorted = _.sortBy(this.getter(property), function (model) {
        return String(model[field]).toLowerCase();
      });
      return sorted;
    }
  });
  return AbstractService;
});

